<script setup lang="ts">import { ref as _ref, computed as _computed } from 'vue';

import { useRoute } from 'vue-router/composables';
import SModal from '@/components/SModal.vue';
import STextField from '@/components/STextField/STextField.vue';
import { isRequired } from '@/utils/rules';
import type { Location } from 'vue-router';
import SLabel from '@/components/SLabel.vue';

interface SaveSearchButtonEmits {
  (e: 'save', name: string, query: Location['query']): void;
}

const emit = defineEmits(["save"]);

const route = useRoute();

const modal = _ref<InstanceType<typeof SModal> | null>(null);
let name = _ref('');
const isValid = _ref(false);
const handleCancel = () => {
  name.value = '';
};

const canSave = _computed(() => isValid.value && Object.keys(route.query).length > 0);

const handleSave = () => {
  emit('save', name.value, route.query);
  modal.value?.closeModal();
};

const openModal = () => {
  modal.value?.openModal();
};
</script>

<template lang="pug">
.filter-save
  SButton(
    @click="openModal"
    size="small"
    color="primary"
    variant="text"
    :text="$t('common.words.save')"
    data-track="filter-save-button" )
  SModal(
    ref="modal"
    :title="$t('save_search.title')"
    :on-close="handleCancel"
    :on-save="handleSave"
    :can-save="canSave"
    width="600")
    v-form(v-model="isValid" @submit.prevent="handleSave")
      SLabel(label="Name" )  {{ $t('save_search.name') }}
        STextField( #input v-model="name" :placeholder="$t('save_search.input_placeholder')" :rules="[isRequired]")

</template>
